export interface ISnAuthConfig {
  signUpEnabled: boolean;
  ssoEnabled: boolean;
  isRegistry: boolean;
  isVideoMeet: boolean;
  redirectAuthorizedTo: string;
}
